import { render } from "./LieuRDV.vue?vue&type=template&id=5cf59cd5&scoped=true"
import script from "./LieuRDV.vue?vue&type=script&lang=js"
export * from "./LieuRDV.vue?vue&type=script&lang=js"

import "./LieuRDV.vue?vue&type=style&index=0&id=5cf59cd5&scoped=true&lang=css"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5cf59cd5"]])

export default __exports__